import type { AnyAction } from 'redux';

import { FETCH_EVENTS_POPULARITY } from '../../actions/Events/EventsActions';
import { reducerWrapper } from '../../support/utils';
import type { EventsReducerType } from './Types/EventsReducerType';

const INIT_STATE: EventsReducerType = {
  loading: true,
  data: [],
};

const Handler = (state: EventsReducerType, action: AnyAction) => {
  switch (action.type) {
    case FETCH_EVENTS_POPULARITY.response:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    default:
      return state;
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const EventsReducer = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [FETCH_EVENTS_POPULARITY],
  error: [FETCH_EVENTS_POPULARITY],
});

export default EventsReducer;
